/**
 * Created by tschenkel on 8/31/2015.
 */

import { BasicConstants } from "../../constants/BasicConstants";
import { LiveEnvironment } from "./LiveEnvironment";
import { IEnvironment } from "./IEnvironment";

export class LiveBranchingLiveEnvironment extends LiveEnvironment implements IEnvironment {
    public static LIVE_BRANCHING_LIVE_ENVIRONMENT_ID: string = "LiveBranchingLiveEnvironment";

    constructor(id?: string) {
        super(id !== undefined ? id : LiveBranchingLiveEnvironment.LIVE_BRANCHING_LIVE_ENVIRONMENT_ID);
    }

    public initPatterns(): void {
        super.initPatterns();

        this._branchesConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://" + BasicConstants.DOMAIN_INTERNAL_DNS + "/web/Web_PreClient/branches/{gameFileName}/branches.xml";
        this._gameUrlPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://" + BasicConstants.DOMAIN_INTERNAL_DNS + "/web/Web_PreClient/branches/{gameFileName}/{branchId}/{gameTitle}Game_{branchVersion}.swf";
    }

    public isSupported(): boolean {
        return this._data.globals.isLiveBranchingEnvironment;
    }
}
